export class SoldTo {
   _id: string;
   name: string;
   tagNumber?: string;
   employeeCode?: string;
   type?: 'Customer' | 'Employee' | 'WalkIn';
}
